import AppDispatcher         from '~/dispatchers/app_dispatcher';
import BulkSelectActionTypes from '~/types/bulk_select_action_types';

const BulkSelectActions = {

  /**
   * Select a single document item for bulk action
   * @param {Object} table - Document info table
   * @param {Object} documentItem
   */
  selectDocumentItem(table, documentItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_DOCUMENT_ITEM,
      tableScope: table.scope,
      documentItem,
    });
  },

  /**
   * De-select a single document item for bulk action
   * @param {Object} table - Document info table
   * @param {Object} documentItem
   */
  deselectDocumentItem(table, documentItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_DOCUMENT_ITEM,
      tableScope: table.scope,
      documentItem,
    });
  },

  /**
     * Select multiple document items for bulk action
     * @param {Object} table - Document info table
     * @param {Object[]} documentItems - Array of document items to be selected
     */
  selectDocumentItems(table, documentItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_DOCUMENT_ITEMS, // Action type for selecting document items
      tableScope: table.scope, // Scope of the table
      documentItems, // Array of document items to be selected
    });
  },

  /**
   * De-select multiple document items for bulk action
   * @param {Object} table - Document info table
   * @param {Object[]} documentItems - Array of document items to be deselected
   */
  deselectDocumentItems(table, documentItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_DOCUMENT_ITEMS, // Action type for deselecting document items
      tableScope: table.scope, // Scope of the table
      documentItems, // Array of document items to be deselected
    });
  },

  /**
   * Select a single trash document item for bulk action
   * @param {Object} table - Document info table
   * @param {Object} trashDocumentItem
   */
  selectTrashDocumentItem(table, trashDocumentItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_TRASH_DOCUMENT_ITEM,
      tableScope: table.scope,
      trashDocumentItem,
    });
  },

  /**
   * De-select a single trash document item for bulk action
   * @param {Object} table - Document info table
   * @param {Object} trashDocumentItem
   */
  deselectTrashDocumentItem(table, trashDocumentItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_TRASH_DOCUMENT_ITEM,
      tableScope: table.scope,
      trashDocumentItem,
    });
  },

  /**
   * Select multiple trash document items for bulk action
   * @param {Object} table - Document info table
   * @param {Object[]} trashDocumentItems - Array of trash document items to be selected
   */
  selectTrashDocumentItems(table, trashDocumentItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_TRASH_DOCUMENT_ITEMS,
      tableScope: table.scope,
      trashDocumentItems,
    });
  },

  /**
   * De-select multiple trash document items for bulk action
   * @param {Object} table - Document info table
   * @param {Object[]} trashDocumentItems - Array of trash document items to be deselected
   */
  deselectTrashDocumentItems(table, trashDocumentItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_TRASH_DOCUMENT_ITEMS,
      tableScope: table.scope,
      trashDocumentItems,
    });
  },

  /**
   * Select all items for bulk action
   * @param {Object} table - Lead/Task info table
   */
  selectAllItems(table) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_ALL_ITEMS,
      tableScope: table.scope,
    });
  },

  /**
   * De-select all items for bulk action
   * @param {Object} table - Lead/Task info table
   */
  deselectAllItems(table) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_ALL_ITEMS,
      tableScope: table.scope,
    });
  },

  /**
   * Select multiple lead items for bulk action
   * @param {Object} table - Lead/Task info table
   * @param {Object[]} leadItems
   */
  selectLeadItems(table, leadItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_LEAD_ITEMS,
      tableScope: table.scope,
      leadItems,
    });
  },

  /**
   * De-select multiple lead items for bulk action
   * @param {Object} table - Lead/Task info table
   * @param {Object[]} leadItems
   */
  deselectLeadItems(table, leadItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_LEAD_ITEMS,
      tableScope: table ? table.scope : null,
      leadItems,
    });
  },

  /**
   * Select a single lead item for bulk action
   * @param {Object} table - Lead/Task info table
   * @param {Object} leadItem
   */
  selectLeadItem(table, leadItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_LEAD_ITEM,
      tableScope: table.scope,
      leadItem,
    });
  },

  /**
   * De-select a single lead item for bulk action
   * @param {Object} table - Lead/Task info table
   * @param {Object} leadItem
   */
  deselectLeadItem(table, leadItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_LEAD_ITEM,
      tableScope: table.scope,
      leadItem,
    });
  },

  /**
   * Select a single video item for bulk action
   * @param {Object} table - Video info table
   * @param {Object} videoItem
   */
  selectVideoItem(table, videoItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_VIDEO_ITEM,
      tableScope: table.scope,
      videoItem,
    });
  },

  /**
   * De-select a single video item for bulk action
   * @param {Object} table - Video info table
   * @param {Object} videoItem
   */
  deselectVideoItem(table, videoItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_VIDEO_ITEM,
      tableScope: table.scope,
      videoItem,
    });
  },

  /**
   * Select multiple video items for bulk action
   * @param {Object} table - Video info table
   * @param {Object[]} videoItems - Array of video items to be selected
   */
  selectVideoItems(table, videoItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_VIDEO_ITEMS,
      tableScope: table.scope,
      videoItems,
    });
  },

  /**
   * De-select multiple video items for bulk action
   * @param {Object} table - Video info table
   * @param {Object[]} videoItems - Array of video items to be deselected
   */
  deselectVideoItems(table, videoItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_VIDEO_ITEMS,
      tableScope: table.scope,
      videoItems,
    });
  },

  /**
   * Select a single trash video item for bulk action
   * @param {Object} table - Video info table
   * @param {Object} trashVideoItem
   */
  selectTrashVideoItem(table, trashVideoItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_TRASH_VIDEO_ITEM,
      tableScope: table.scope,
      trashVideoItem,
    });
  },

  /**
   * De-select a single trash video item for bulk action
   * @param {Object} table - Video info table
   * @param {Object} trashVideoItem
   */
  deselectTrashVideoItem(table, trashVideoItem) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_TRASH_VIDEO_ITEM,
      tableScope: table.scope,
      trashVideoItem,
    });
  },

  /**
   * Select multiple trash video items for bulk action
   * @param {Object} table - Video info table
   * @param {Object[]} trashVideoItems - Array of trash video items to be selected
   */
  selectTrashVideoItems(table, trashVideoItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.SELECT_TRASH_VIDEO_ITEMS,
      tableScope: table.scope,
      trashVideoItems,
    });
  },

  /**
   * De-select multiple trash video items for bulk action
   * @param {Object} table - Video info table
   * @param {Object[]} trashVideoItems - Array of trash video items to be deselected
   */
  deselectTrashVideoItems(table, trashVideoItems) {
    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes.DESELECT_TRASH_VIDEO_ITEMS,
      tableScope: table.scope,
      trashVideoItems,
    });
  },

  /**
   * Generic method to select/deselect single or multiple items for bulk action
   * @private
   * @param {string} entityType - The entity type ('JOB' or 'CANDIDATE')
   * @param {string} action - The action ('SELECT' or 'DESELECT')
   * @param {string} itemType - The item type ('ITEM' or 'ITEMS')
   * @param {Object} table - The table object containing scope
   * @param {Object|Object[]} items - Single item or array of items
   */
  _dispatchBulkAction(entityType, action, itemType, table, items) {
    const actionType = `${action}_${entityType}_${itemType}`;
    const propName = `${entityType.toLowerCase()}${itemType.toLowerCase() === 'item' ? 'Item' : 'Items'}`;

    AppDispatcher.dispatch({
      type:       BulkSelectActionTypes[actionType],
      tableScope: table.scope,
      [propName]: items,
    });
  },

  /**
   * Select a single job item for bulk action
   * @param {Object} table - Job info table
   * @param {Object} jobItem
   */
  selectJobItem(table, jobItem) {
    this._dispatchBulkAction('JOB', 'SELECT', 'ITEM', table, jobItem);
  },

  /**
   * De-select a single job item for bulk action
   * @param {Object} table - Job info table
   * @param {Object} jobItem
   */
  deselectJobItem(table, jobItem) {
    this._dispatchBulkAction('JOB', 'DESELECT', 'ITEM', table, jobItem);
  },

  /**
   * Select multiple job items for bulk action
   * @param {Object} table - Job info table
   * @param {Object[]} jobItems - Array of job items to be selected
   */
  selectJobItems(table, jobItems) {
    this._dispatchBulkAction('JOB', 'SELECT', 'ITEMS', table, jobItems);
  },

  /**
   * De-select multiple job items for bulk action
   * @param {Object} table - Job info table
   * @param {Object[]} jobItems - Array of job items to be deselected
   */
  deselectJobItems(table, jobItems) {
    this._dispatchBulkAction('JOB', 'DESELECT', 'ITEMS', table, jobItems);
  },

  /**
   * Select a single candidate item for bulk action
   * @param {Object} table - Candidate info table
   * @param {Object} candidateItem
   */
  selectCandidateItem(table, candidateItem) {
    this._dispatchBulkAction('CANDIDATE', 'SELECT', 'ITEM', table, candidateItem);
  },

  /**
   * De-select a single candidate item for bulk action
   * @param {Object} table - Candidate info table
   * @param {Object} candidateItem
   */
  deselectCandidateItem(table, candidateItem) {
    this._dispatchBulkAction('CANDIDATE', 'DESELECT', 'ITEM', table, candidateItem);
  },

  /**
   * Select multiple candidate items for bulk action
   * @param {Object} table - Candidate info table
   * @param {Object[]} candidateItems - Array of candidate items to be selected
   */
  selectCandidateItems(table, candidateItems) {
    this._dispatchBulkAction('CANDIDATE', 'SELECT', 'ITEMS', table, candidateItems);
  },

  /**
   * De-select multiple candidate items for bulk action
   * @param {Object} table - Candidate info table
   * @param {Object[]} candidateItems - Array of candidate items to be deselected
   */
  deselectCandidateItems(table, candidateItems) {
    this._dispatchBulkAction('CANDIDATE', 'DESELECT', 'ITEMS', table, candidateItems);
  },
};

export default BulkSelectActions;
